import { Currency } from '~/codegen/graphql'
import { GetOrgMetadataDocument } from './use-org-metadata.generated'

export default function () {
  const { data, isFetching, isDone } = useQuery({
    query: GetOrgMetadataDocument,
    tags: ['org-metadata'],
  })

  const llmFeaturesEnabled = computed(() =>
    Boolean(data.value?.organization.llmFeaturesEnabled))
  const timezone = computed(() => data.value?.organization.timezone ?? '')
  const name = computed(() => data.value?.organization.name ?? '')
  const currency = computed(() => data.value?.organization.developerSalaries[0]?.currency ?? Currency.Usd)

  return { llmFeaturesEnabled, timezone, name, isFetching, isDone, currency }
}
